import { produce } from "immer";
import { TYPE_FETCHED } from './InstrumentDataConstants';

const assign = Object.assign || require('object.assign');

export default function InstrumentDataReducer( state= {}, action) {

    switch (action.type) {
        case TYPE_FETCHED : {
            const newState = produce(state, (draft) => {
                draft[action.deviceID] = {
                    ...draft[action.deviceID],
                    selectedType: action.newState
                }
            });
            return assign({}, state, newState);
        }
        default:
            return state;
    }
}